import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function ProblemSection() {
  return <SectionWrapper bgColor="warmWhite" data-id="element-189">
      <h2 className="font-serif text-3xl md:text-4xl font-bold text-dark mb-6 leading-tight text-center" data-id="element-190">
        El Problema No Está Donde Todos Te Dijeron Que Estaba
      </h2>

      <div className="font-sans text-lg text-gray-800 space-y-4 leading-relaxed" data-id="element-191">
        <p data-id="element-192">
          Durante años, la industria del fitness te vendió la misma mentira:
        </p>

        <p className="text-center font-medium text-xl italic text-gray-600 my-4" data-id="element-193">
          "Come menos. Muévete más. Toma más agua."
        </p>

        <p data-id="element-194">Y tú lo intentaste. Dios sabe que lo intentaste.</p>

        <ul className="space-y-3 my-5" data-id="element-195">
          <li className="flex items-start gap-3" data-id="element-196">
            <span className="text-urgency mt-1" data-id="element-197">❌</span>
            <span data-id="element-198">
              Probaste las dietas de 1,200 calorías que te dejaban con dolor de
              cabeza y mal humor.
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-199">
            <span className="text-urgency mt-1" data-id="element-200">❌</span>
            <span data-id="element-201">
              Probaste los jugos verdes de $12 dólares que solo te hacían correr
              al baño.
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-202">
            <span className="text-urgency mt-1" data-id="element-203">❌</span>
            <span data-id="element-204">
              Probaste el cardio de 5 AM que te dejaba más agotada de lo que
              empezabas.
            </span>
          </li>
        </ul>

        <p data-id="element-205">Y el vientre... seguía ahí.</p>

        <p data-id="element-206">¿Sabes por qué?</p>

        <p data-id="element-207">Porque ninguna de esas soluciones ataca el problema real.</p>

        <div className="bg-cream p-5 rounded-2xl border border-accent/20 mt-5 text-center shadow-sm" data-id="element-208">
          <p className="font-serif text-2xl font-bold text-primary" data-id="element-209">
            El problema real tiene nombre: <br className="md:hidden" data-id="element-210" />
            <span className="text-urgency" data-id="element-211">hígado saturado.</span>
          </p>
        </div>
      </div>
    </SectionWrapper>;
}